module.exports = __webpack_public_path__ + "static/media/champagne_glasses.cb439bad.svg";